import {Model} from './Model';
import {PrivacyStatement} from './PrivacyStatement';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

export class Client extends Model implements SessionStorageObject {
  public title: string;
  public www: string;
  public email: string;
  public phone: string;
  public color: { [key: string]: any };
  public contacts: { [key: string]: any };
  public ebmsId: number;
  public address: string;
  public zip: string;
  public city: string;
  public companiesRegisterNumber: string;
  public courtOfRegistration: string;
  public vatId: string;
  public creditorNumber: number;
  public bankAccount: { [key: string]: any };
  public invoiceNumberRange: { [key: string]: any };
  public invoicePDFLayoutId: number;
  public dataProtectionDeclId: number;
  public termsAndConditionsId: number;
  public glAccountDiscounts: number;
  public translations: { [key: string]: any };

  // filled later on in the checkout process
  public termsAndConditions: any = null;
  public privacyStatement: PrivacyStatement | null = null;

  constructor(data: any) {
    super(data);

    this.title = data.title;
    this.www = data.www;
    this.email = data.email;
    this.phone = data.phone;
    this.color = data.color;
    this.contacts = data.contacts;
    this.ebmsId = data.ebmsId;
    this.address = data.address;
    this.zip = data.zip;
    this.city = data.city;
    this.companiesRegisterNumber = data.companiesRegisterNumber;
    this.courtOfRegistration = data.courtOfRegistration;
    this.vatId = data.vatId;
    this.creditorNumber = data.creditorNumber;
    this.bankAccount = data.bankAccount;
    this.invoiceNumberRange = data.invoiceNumberRange;
    this.invoicePDFLayoutId = data.invoicePDFLayoutId;
    this.dataProtectionDeclId = data.dataProtectionDeclId;
    this.termsAndConditionsId = data.termsAndConditionsId;
    this.glAccountDiscounts = data.glAccountDiscounts;
    this.translations = data.translations;
  }

  fromStorage(data: any) {
    return new Client(data);
  }

  toString(): string {
    return this.title;
  }
}
